export default class MonthResultInformation
{
    /// <summary>
    /// 売上高 - 104
    /// </summary>
    get Row_OrigKeikaku_SalesAmount() {return 104;}
    /// <summary>
    /// 営業総益 - 105
    /// </summary>
    get Row_OrigKeikaku_GrossOperatingProfit() {return 105;}
    /// <summary>
    /// 売上高 - 120
    /// </summary>
    get Row_SalesAmount() {return 120;}
    /// <summary>
    /// 営業総益 - 121
    /// </summary>
    get Row_GrossOperatingProfit() {return 121;}

    constructor(year, monthNumber)
    {
        this.Year = year;
        this.Month = monthNumber;
        // Since column is set to 0
        // here, it can't be used yet
        // cause columns a not 0-based
        // indexed
        this.Column = 0;
        this.Sales = 0;
        this.ProvProfit = 0;
        this.Profit = 0;
        this.OperatingProfit = 0;
        this.Zaiko = 0;
        this.NetIncome = 0;
        this.DestroyCost = 0;

        // PRODUCT TYPE SPECIFIC
        this.Games_SalesAmount;
        this.Games_GrossOperatingProfit;
        this.Games_ResultGrossOperatingProfit;
        this.Games_SubtractFromSales;
        this.Games_SubtractFromGrossProfit;
        this.Games_AddToSales;

        this.PlasticModel_SalesAmount;
        this.PlasticModel_GrossOperatingProfit;
        this.PlasticModel_ResultGrossOperatingProfit;
        this.PlasticModel_AddToStock;
        this.PlasticModel_SubtractFromStock;
        this.PlasticModel_SubtractFromSales;
        this.PlasticModel_SubtractFromGrossProfit;
        this.PlasticModel_SampleCost;
        this.PlasticModel_AddSampleCostToGrossProfit;
        this.PlasticModel_AddToSales;
        this.PlasticModel_ProductCount;

        this.Digital_SalesAmount;
        this.Digital_GrossOperatingProfit;
        this.Digital_ResultGrossOperatingProfit;
        this.Digital_AddToStock;
        this.Digital_SubtractFromStock;
        this.Digital_SubtractFromSales;
        this.Digital_SubtractFromGrossProfit;
        this.Digital_SampleCost;
        this.Digital_AddSampleCostToGrossProfit;
        this.Digital_AddToSales;
        this.Digital_ProductCount;

        this.Figures_SalesAmount;
        this.Figures_GrossOperatingProfit;
        this.Figures_ResultGrossOperatingProfit;
        this.Figures_AddToStock;
        this.Figures_SubtractFromStock;
        this.Figures_SubtractFromSales;
        this.Figures_SubtractFromGrossProfit;
        this.Figures_SampleCost;
        this.Figures_AddSampleCostToGrossProfit;
        this.Figures_AddToSales;
        this.Figures_ProductCount;
    }

    get Sales_Figures()
    {
        return Math.round(this.Figures_SalesAmount) - Math.round(this.Figures_SubtractFromSales) - 20 + Math.round(this.Figures_AddToSales);
    }

    get Sales_PlasticModel()
    {
        return Math.round(this.PlasticModel_SalesAmount) - Math.round(this.PlasticModel_SubtractFromSales) + Math.round(this.PlasticModel_AddToSales);
    }

    get Sales_Digital()
    {
        return Math.round(this.Digital_SalesAmount) - Math.round(this.Digital_SubtractFromSales) + Math.round(this.Digital_AddToSales);
    }

    get Sales_Games()
    {
        return Math.round(this.Games_SalesAmount) - Math.round(this.Games_SubtractFromSales) + Math.round(this.Games_AddToSales);
    }

    /// <summary>
    /// Calculates the gross profit based on GrossOperatingProfit + SampleCost - SubtractFromGrossProfit + AddSampleCostToGrossProfit - DestroyCost - 10
    /// </summary>
    get GrossProfit_Figures()
    {
        return Math.round(this.Figures_GrossOperatingProfit) + Math.round(this.Figures_SampleCost) - Math.round(this.Figures_SubtractFromGrossProfit) + Math.Abs(Math.round(this.Figures_AddSampleCostToGrossProfit)) - this.DestroyCost - 10;
    }

    get GrossProfit_PlasticModel()
    {
        return Math.round(this.PlasticModel_GrossOperatingProfit) + Math.round(this.PlasticModel_SampleCost) - Math.round(this.PlasticModel_SubtractFromGrossProfit) + Math.Abs(Math.round(this.PlasticModel_AddSampleCostToGrossProfit));
    }

    get GrossProfit_Digital()
    {
        return Math.round(this.Digital_GrossOperatingProfit) + Math.round(this.Digital_SampleCost) - Math.round(this.Digital_SubtractFromGrossProfit) + Math.Abs(Math.round(this.Digital_AddSampleCostToGrossProfit));
    }

    get GrossProfit_Games()
    {
        return Math.round(this.Games_GrossOperatingProfit) - Math.round(this.Games_SubtractFromGrossProfit);
    }
}